import React, { useState } from "react";
import { Button, Modal, CloseButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import adaswaplogo from "../assets/images/adaswaplogo.png";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import SelectToken from "../Modals/SelectToken";
import "./CreatePair.css";

function CreatePair() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="model-create-wraper">
        <Button className="CreatePair transition" onClick={handleShow}>
          Create a Pair
        </Button>
        <Modal show={show} onHide={handleClose} className="create-modal">
          <Modal.Header>
            <span className="cur-poi" onClick={handleClose}>
              <FontAwesomeIcon icon={faArrowLeft} className="left-arrow" />
            </span>
            <Modal.Title className="text-white d-flex justify-content-center">
              Create a Pair
            </Modal.Title>
            <CloseButton variant="white" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body className="pair---create-model">
            <div className="d-flex">
              <div className="liquidity-provider">
                <h6>You are the first liquidity provider</h6>
                <p>
                  The ratio of tokens you add will set the price. Once you are
                  ok with the rate click supply to review.
                </p>
              </div>
            </div>
            <div className="swapPage-content">
              <div className="swap-farm-fields">
                <div className="field-one-iner d-flex justify-content-between align-items-center">
                  <div className="d-flex flex-column">
                    <div className="field-one">
                      <h2>Input</h2>
                    </div>
                    <div className="d-flex">
                      <h3>0.0</h3>
                    </div>
                    <div className="field-one">
                      <h2>Balance: 2.4000</h2>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="max-text me-2 me-md-4">Max</span>
                    <div className="d-flex right-ada align-items-center">
                      <span className="adaswaplogo">
                        <img src={adaswaplogo} alt="" />
                      </span>
                      <h3>Ada</h3>
                      <FontAwesomeIcon icon={faChevronDown} className="ms-2 angle-down text-white"/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center box-two">
                <div className="arrow-down-circle">
                  <a href="#" target="_blank">
                    <FontAwesomeIcon icon={faPlus} />
                  </a>
                </div>
              </div>
              <div className="swap-farm-fields">
                <div className="field-one-iner d-flex justify-content-between align-items-center">
                  <div className="d-flex flex-column">
                    <div className="field-one">
                      <h2>Input</h2>
                    </div>
                    <div className="d-flex">
                      <h3>0.0</h3>
                    </div>
                    <div className="field-one">
                      <h2>Balance: 2.4000</h2>
                    </div>
                  </div>
                  <div className="d-flex">
                    <SelectToken />
                  </div>
                </div>
              </div>
              <div className="d-flex Invalid-pair-btn">
                <Button
                  className=" swap--button w-100"
                  variant="primary"
                  size="lg"
                  onClick={handleShow}
                >
                  Invalid Pair
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default CreatePair;
